import React, {useState} from 'react'
import {Button, Icon} from 'antd'
import PropTypes from 'prop-types'
import coachingLogo from '../assets/images/Health-coach-logo@3x.png'
import blog from '../assets/images/Blog-icon.png'
import {Link} from 'gatsby'

const Header = (props) => {
  const [state, setState] = useState(false)
  const { isContentWhite } = props;
  return (
    <>
      <header id="header" className="alt">
        <nav className='header-nav'>
            <Link to="/" hidden={props.show && state}
                  style={{ display: 'flex', alignItems: 'center', width: 200,padding:0 }}>
              <img style={{ marginBottom: -5, width: '100%' }} src={coachingLogo} alt='Home'/>
            </Link>
          <div style={{ display: 'flex',alignItems:'center' }}>
            {props.show && !state ?
              <>
                {/*<Link to="/coaching/features" className='margin-right-25'>*/}
                {/*<div className={`menu-content hide-content ${props.isLogoWhite ? 'white-text':''}`} href="javascript:;">Features</div>*/}
                {/*</Link>*/}
                {/*<Link to="/pricing" activeClassName='header-nav-active' className='margin-right-25 header-content'>
                  <div className={`menu-content`} href="javascript:;">
                    <img src={pricing} /> {'  '}Pricing
                  </div>
                </Link>*/}
                {/*<Link activeClassName='header-nav-active' to="/case-studies" className='margin-right-25 header-content'>
                  <div className={`menu-content`}
                       href="javascript:;">
                    <img src={caseStudy}/> {'  '}
                    Case Studies
                  </div>
                </Link>*/}
                <a href="http://resiliens.com/blog" className='margin-right-25 header-content'>
                  <div className={`menu-content`}
                       href="javascript:;">
                    <img src={blog}/> {'  '}
                    Blog
                  </div>
                </a>
              </> : ''}
            <a
              href="https://provider.swasth.co"
              hidden={props.show}
            >
              <div className="menu-content">Clinicians</div>
            </a>
            {props.show ?
              <a
                className='menu-fold-icon'
                href='javascript:void(0)'
                onClick={() => setState(!state)}>
                {state ? <Icon className='icon' type="close"/>
                  : <Icon className={`icon ${isContentWhite ? 'not-white' :''}`} type="menu"/>}
              </a> : ''
            }
          </div>
          {props.show && !state ?
          <Link to="/download">
            <Button className='download-btn base-text menu-content hide-content'>Download App</Button>
          </Link> : null}
        </nav>
      </header>
      {
        props.show && state ?
          <div className='menu-fold-content'>
            {/*<Link to/features">*/}
            {/*<div className="menu-content">Features</div>*/}
            {/*</Link>*/}
            <a href="/">
              <div className="menu-content" href="javascript:;">Home</div>
            </a>
          {/*  <a href="/pricing">
              <div className="menu-content">Pricing</div>
            </a>*/}
            <a href="http://resiliens.com/blog">
              <div className="menu-content">Blog</div>
            </a>
            <a href="/download">
              <div className="menu-content">Download App</div>
            </a>
          </div> : ''
      }
    </>
  )
}
Header.propTypes = {
  onToggleMenu: PropTypes.func,
}

export default Header
